
export enum BankValidationStatus {
  Validated = "Validated",
}

export enum ChallengeReasons {
  AgreementDetailsWrong = "agreementDetailsWrong",
  PaymentOrSettlementHistoryWrong = "paymentOrSettlementHistoryWrong",
  CommissionArrangementOrInterestRateAssessment = "commissionArrangementOrInterestRateAssessment",
  DealerRelationshipWithLenderAssessment = "dealerRelationshipWithLenderAssessment",
  RedressCalculatedIncorrectly = "redressCalculatedIncorrectly",
  AnotherReason = "anotherReason",
}

export enum ContactPreference {
  Email = "Email only",
  Post = "Post only",
}

export enum PortalState {
  NoRedressStart = "noRedressStart",
  OptedOut = "optedOut",
  Cancelled = "cancelled",
  Unknown = "unknown",
  ChallengeIntent = "challengeIntent",
  ChallengeSubmitted = "challengeSubmitted",
  NoRedressFinal = "noRedressFinal",
  NoRedressAssessment = "noRedressAssessment",
  NoRedressClosed = "noRedressClosed",
}

export enum RedressParticipation {
  OPTED_IN = "Opted In",
  OPTED_OUT = "Opted Out",
  NONE = "",
}

export enum CaseStatus {
  OPEN = "Open Complaint",
  CLOSED = "Closed",
  CANCELLED = "Cancelled",
  NEW = "New",
  IN_PROGRESS = "In Progress",
  AWAITING_INFORMATION = "Awaiting Information",
  IN_REVIEW = "In Review",
  PHISHING = "Phishing",
  AWAITING_FCA_RULING = "Awaiting FCA Ruling",
  DUPLICATE = "Duplicate",
  EXCLUDED = "Excluded",
  NEW_COMPLAINT_RAISED = "New Complaint Raised",
  REFER_TO_CASE_CLINIC = "Refer to Case Clinic",
}

export enum ActiveTouchpoint {
  PROVISIONAL_DETERMINATION = "Provisional Redress",
  INTENT_TO_OBJECT = "Intent to Object",
  FORMAL_OBJECTION = "Formal Objection",
  REDRESS_DETERMINATION = "Redress Determination",
  EXCEPTION_INSOLVENCY = "Exception - Insolvency",
  EXCEPTION_BEREAVEMENT = "Exception - Bereavement",
  EMPTY = "",
  ACCEPTANCE = "Acceptance",
  OPT_IN_ACKNOWLEDGEMENT = "Opt In Acknowledgement",
  OPT_IN_FOLLOWUP = "Opt In Follow-up",
  OPT_IN_INVITATION = "Opt In Invitation",
  OPT_OUT_ACKNOWLEDGEMENT = "Opt Out Acknowledgement",
  PAYMENT = "Payment",
  REDRESS_DETERMINATION_CHASER = "Redress Determination Chaser",
}
